import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { PlanForm } from "../PlanForm";
import { CreatePlanModalProps } from "./types";
import { useCreatePlanModal } from "./controller";

export const CreatePlanModal = React.memo(
  ({ modalRef, onComplete }: CreatePlanModalProps) => {
    const translate = useTranslate();

    const { methods, mutateAsync, isPending } = useCreatePlanModal(
      modalRef,
      onComplete
    );

    return (
      <Modal
        ref={modalRef}
        title={translate("subscription_plan_admin.titles.create")}
        onConfirm={mutateAsync}
        methods={methods}
        isPending={isPending}
      >
        <PlanForm />
      </Modal>
    );
  }
);
